import { render, staticRenderFns } from "./afterSaleView.vue?vue&type=template&id=678bfabf&scoped=true&"
import script from "./afterSaleView.vue?vue&type=script&lang=js&"
export * from "./afterSaleView.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleView.vue?vue&type=style&index=0&id=678bfabf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678bfabf",
  null
  
)

export default component.exports